export const atLeastOne = (message: string) => (value: unknown[]) => {
  if (value.length === 0) {
    return message;
  }
};

export const nonEmptyString = (message: string) => (value: string) => {
  if (!/\S/.test(value)) {
    return message;
  }
};
